import { Outlet, useLocation } from "react-router-dom";
import { Topbar } from "@/components/Topbar";
import { Footer } from "@/components/Footer";
import { CookieBanner } from "@/components/CookieBanner";
import { useThemeHydration } from "@/lib/theme";
import { useNotificationsStream } from "@/features/notifications/useNotificationsStream";

/**
 * Mirrors `templates/base.html` shell: <div.app-shell> > header.topbar +
 * main.app-main > .container + footer.app-footer + cookie banner.
 *
 * Some pages (e.g. login) replace the `.container` wrapper with their own
 * full-bleed layout. Pass `bare` to skip the inner `.container` wrapper.
 */
export function AppLayout({ bare = false }: { bare?: boolean }) {
  useThemeHydration();
  useNotificationsStream();
  const location = useLocation();

  // The login page renders its own .login-page full-bleed wrapper inside
  // <main>; everywhere else uses the legacy .container wrapper.
  const isBare = bare || location.pathname.startsWith("/auth/");

  return (
    <div className="app-shell">
      <Topbar />
      <main className="app-main">
        {isBare ? <Outlet /> : <div className="container"><Outlet /></div>}
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
